import styles from "../styles/ui/Popup.module.css";
import { useState } from "react";
import { IoClose } from "react-icons/io5";

function Popup({
  title,
  btnClassName = "",
  popupClassName = "",
  children,
  height = "50%",
  closePopup = false,
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <span
        className={`${btnClassName}`}
        onClick={() => setIsOpen(true)}
        style={{ cursor: "pointer" }}
      >
        {title}
      </span>

      <div
        className={`${styles.overlay} ${isOpen ? styles.show : styles.hidden}`}
        id="overlay"
        onClick={(e) => {
          if (e.target.id === "overlay" && closePopup) {
            setIsOpen(false);
          }
        }}
      >
        <div
          className={`${styles.popup} ${isOpen ? styles.open : styles.close} ${popupClassName}`}
          style={{ maxHeight: height }}
        >
          <span
            className={styles.closeIcon}
            onClick={() => {
              setIsOpen(false);
            }}
          >
            <IoClose size={20} />
          </span>
          {children}
        </div>
      </div>
    </>
  );
}

export default Popup;
